import { OverviewRecommendationsSectionEmptyState_organization$key } from '#app/__generated__/relay/OverviewRecommendationsSectionEmptyState_organization.graphql.js';
import { Text } from '#app/components/Primitives/Text.js';
import EmptyStateImage from './assets/recommendations-empty.webp';
import {
  EmptyStateCard,
  Image,
  MessageContainer,
} from './EmptyState.styles.js';
import { graphql, useFragment } from '@contra/relay';

type OverviewRecommendationsSectionEmptyStateProps = {
  readonly organizationRef: OverviewRecommendationsSectionEmptyState_organization$key;
};

export const OverviewRecommendationsSectionEmptyState = ({
  organizationRef,
}: OverviewRecommendationsSectionEmptyStateProps) => {
  const organization =
    useFragment<OverviewRecommendationsSectionEmptyState_organization$key>(
      graphql`
        fragment OverviewRecommendationsSectionEmptyState_organization on Organization {
          name
          visitorIsMember
        }
      `,
      organizationRef,
    );

  const isMember = organization.visitorIsMember;

  return (
    <EmptyStateCard>
      <Image
        alt="Image of a recommendation listing with 3D glass macaroni behind it"
        src={EmptyStateImage}
      />
      <MessageContainer>
        <Text
          as="h3"
          color="gray80"
          textStyle="subtitleRegular"
        >
          {organization.name ?? 'Organization'} has not received any
          recommendations.
        </Text>
        <Text
          color="gray70"
          textStyle="bodySmall"
        >
          {isMember ? (
            <>
              Your teams recommendations will appear here. Build your reputation
              and attract top contractors.
            </>
          ) : (
            <>
              As {organization.name ?? 'Organization'} receives recommendations,
              they'll be visible on this page.
            </>
          )}
        </Text>
      </MessageContainer>
    </EmptyStateCard>
  );
};
